import { render, staticRenderFns } from "./GalleryNav.vue?vue&type=template&id=0a04eca4&"
import script from "./GalleryNav.vue?vue&type=script&lang=js&"
export * from "./GalleryNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports